module.exports = __webpack_public_path__ + "static/img/1.907dbb38.jpg";